export default "__VITE_ASSET__eabc686d__"